import { setZipStatus } from './filePlayerSlice';

export const handleZipNotifier = (type, data, dispatch) => {
  switch (type) {
  case 'zip_file_ready':
    dispatch(setZipStatus({ zipStatus: 'ready', zipUrl: data.url, zipDismissed: false }));
    return true;

  case 'zip_file_failed':
    dispatch(setZipStatus({ zipStatus: 'failed', zipDismissed: false }));
    return true;

  default:
    return false;
  }
};
